import { useState } from "react";
import { FaRegImage } from "react-icons/fa";

// Imagen con skeleton (placeholder animado) + carga diferida (lazy) + fade-in.
// Mejora la percepción de carga en grillas de tarjetas y galerías.
//
// Props:
// - src, alt: lo habitual de <img>
// - className: clases del contenedor (definir aquí el tamaño, ej. "w-full h-60")
// - imgClassName: clases de la <img> (ej. "object-cover")
// - cualquier otra prop (onClick, etc.) se pasa al <img>
function ImageWithSkeleton({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative overflow-hidden bg-gray-100 ${className}`}>
      {!loaded && (
        <div className="absolute inset-0 bg-gray-200">
          <div className="absolute inset-0 flex items-center justify-center">
            <FaRegImage className="w-8 h-8 text-gray-300" />
          </div>
          <div className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/70 to-transparent" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className={`${imgClassName} transition duration-500 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        {...rest}
      />
    </div>
  );
}

export default ImageWithSkeleton;
